import React from "react";
import Checkbox from "@mui/material/Checkbox";
import "./SideBarLayer.scss";

interface Props {
  name: string;
  selected: boolean;
  onSelectedChange: (c: boolean) => void;
}

export default function SideBarLayer(props: Props) {
  const onSelectedChange = (e: React.BaseSyntheticEvent) => {
    props.onSelectedChange(!props.selected);
  };

  const selectedClass = props.selected ? "selected" : "";

  return (
    <div className={`SideBarLayer ${selectedClass}`} onClick={onSelectedChange}>
      <span>{props.name}</span>
    </div>
  );
}
